<template>
  <div class="page">
    <box>
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="通道编号" class="EL-Form-Item">
            <el-select
              v-model="mainSearch.whCode"
              placeholder="请选择"
              filterable
              clearable="clearable"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.whId"
                :label="item.whCode + '-' + item.whName"
                :value="item.whCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.matCode"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="拣货单号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.spCode"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="拣货状态" class="EL-Form-Item">
            <el-select
              v-model="pickStatus"
              placeholder="请选择"
              clearable="clearable"
            >
              <!-- <el-option label="创建" value="CREATE" /> -->
              <el-option label="待拣配,拣配中" value="WAITEXECUTE,EXECUTE" />
              <!-- <el-option label="待拣配" value="WAITEXECUTE" /> -->
              <!-- <el-option label="拣配中" value="EXECUTE" /> -->
              <el-option label="完成" value="COMPLETE" />
              <el-option label="取消" value="CANCEL" />
              <el-option label="关闭" value="CLOSE" />
              <el-option label="全部" value="" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="saveSearch()">
              查询
            </el-button>
            <el-button class="btn-t-delete" @click="mainReset()">
              重置
            </el-button>
          </el-form-item>
        </el-col>

        <el-col :lg="5" :xl="5">
          <el-form-item label="拣货类型" class="EL-Form-Item">
            <el-select v-model="mainSearch.operaType" placeholder="请选择">
              <el-option label="全部" value="10,30,60" />
              <el-option label="生产叫料" value="10" />
              <!-- <el-option label="部门领用" value="20" /> -->
              <el-option label="采购退货" value="30" />
              <el-option label="外协" value="60" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="开始日期" class="EL-Form-Item">
            <el-date-picker
              v-model="mainSearch.date[0]"
              value-format="yyyy-MM-dd HH:mm"
              type="date"
              placeholder="开始日期"
              :picker-options="pickerOptions0"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="结束日期" class="EL-Form-Item">
            <el-date-picker
              v-model="mainSearch.date[1]"
              value-format="yyyy-MM-dd HH:mm"
              type="date"
              placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料类型" class="EL-Form-Item">
            <el-select v-model="mainSearch.materialType" placeholder="请选择">
              <el-option label="全部" value="" />
              <el-option label="套圈" value="套圈" />
              <el-option label="油脂" value="油脂" />
              <el-option label="密封圈" value="密封圈" />
              <el-option label="防尘盖" value="防尘盖" />
              <el-option label="保持器" value="保持器" />
              <el-option label="钢球" value="钢球" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
    </box>
    <box fill>
      <plabel text="拣货确认列表">
        <el-button
          v-authority="'BACK_MENU3_M11_B1'"
          class="btn-t-edit"
          @click="getPrintList()"
          >单据打印</el-button
        >
        <el-button
          v-authority="'BACK_MENU3_M11_B2'"
          :loading="downloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFile()"
          >导出EXCEL</el-button
        >
      </plabel>
      <h-table
        :headerCellStyle="mainData.headerCellStyle"
        style="flex: 1"
        @pageChange="getStockPickPage"
        :data="mainData.data"
        pagination
        :nowPage.sync="mainData.nowPage"
        :pageSize.sync="mainData.pageSize"
        :total.sync="mainData.total"
        @selectionChange="checkboxMain"
      >
        <el-table-column type="selection" align="center"> </el-table-column>
        <el-table-column label="通道编号" prop="whCode" align="center">
          <template slot-scope="scope">
            {{ scope.row.realWhCode }}
            <span v-if="scope.row.whCode != scope.row.realWhCode"
              >({{ scope.row.whCode }})</span
            >
          </template>
        </el-table-column>
        <el-table-column label="物料类型" prop="materialType" align="center">
        </el-table-column>
        <el-table-column label="物料编号" prop="matCode" align="center" min-width="100">
        </el-table-column>
        <el-table-column label="物料描述" prop="matName" align="center" min-width="100">
        </el-table-column>
        <el-table-column label="物料数量" prop="matQuan" align="center">
        </el-table-column>
        <el-table-column
          label="实际拣货数量"
          align="center"
          prop="realPickMat"
        ></el-table-column>
        <el-table-column label="拣货状态" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.spStatus == 'CREATE'">创建</div>
            <div v-if="scope.row.spStatus == 'EXECUTE' && !scope.row.pickFlag">
              待拣配
            </div>
            <div v-if="scope.row.spStatus == 'EXECUTE' && scope.row.pickFlag">
              拣配中
            </div>
            <div v-if="scope.row.spStatus == 'COMPLETE'">完成</div>
            <div v-if="scope.row.spStatus == 'CANCEL'">取消</div>
            <div v-if="scope.row.spStatus == 'CLOSE'">关闭</div>
          </template>
        </el-table-column>
        <el-table-column label="拣货类型" prop="operaType" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.operaType == '10'">生产叫料</div>
            <div v-if="scope.row.operaType == '20'">部门领用</div>
            <div v-if="scope.row.operaType == '30'">采购退货</div>
            <div v-if="scope.row.operaType == '60'">外协</div>
          </template>
        </el-table-column>
        <el-table-column label="拣货单号" prop="spCode" align="center" min-width="100">
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center" min-width="120">
        </el-table-column>
        <el-table-column label="是否紧急" prop="topFlag" align="center">
          <template slot-scope="scope">
            {{ scope.row.topFlag ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column label="紧急原因" prop="topMessage" align="center">
        </el-table-column>
        <el-table-column label="规值" prop="matSpecs" align="center">
        </el-table-column>
        <el-table-column label="拣货人" prop="pickPerson" align="center">
        </el-table-column>
        <el-table-column label="操作人" prop="person" align="center">
        </el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="scope">
            <el-button
              v-authority="'BACK_MENU3_M11_B3'"
              class="btn-t-edit"
              type="primary"
              @click="detailsDialog(scope.row)"
              :disabled="scope.row.spStatus == 'CREATE' ? true : false"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </h-table>
    </box>

    <!-- 拣货列表 -->
    <el-dialog
      title="拣货列表"
      :visible.sync="detailsDialogShow"
      class="fromDialog"
      :style="$popups.popups(0.8, 0.9)"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <!-- 生产叫料 -->
      <el-row
        :gutter="20"
        style="margin: 0"
        v-show="detailsData.operaType == '10'"
      >
        <el-col :span="18" style="border-right: 1px dashed;">
          <h-table
            :headerCellStyle="mainData.headerCellStyle"
            :style="$popups.harvestRecordStyle(0.73)"
            :data="detailsData.data"
            :total.sync="detailsData.total"
            @selectionChange="checkboxDet"
          >
            <el-table-column
              type="selection"
              align="center"
              :selectable="checkboxSelect"
            >
            </el-table-column>
            <el-table-column label="拣货单号" prop="spCode" align="center" min-width="100">
            </el-table-column>
            <el-table-column label="物料编号" prop="matCode" align="center" min-width="100">
            </el-table-column>
            <el-table-column label="物料描述" prop="matName" align="center" min-width="100">
            </el-table-column>
            <el-table-column label="箱内数量" prop="boxQuan" align="center">
            </el-table-column>
            <el-table-column label="实际拣货数量" align="center" prop="matQuan">
            </el-table-column>
            <el-table-column label="拣货扫描" align="center">
              <template slot-scope="scope">
                {{ scope.row.scanFlag ? "已扫描" : "未扫描" }}
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <div v-if="detailsData.operaType == '10'">
                  <span v-if="scope.row.distrType == '10'">待配送</span>
                  <span v-if="scope.row.distrType == '20'">配送中</span>
                  <span v-if="scope.row.distrType == '30'">配送完成</span>
                  <span v-if="scope.row.distrType == '40'">关闭</span>
                </div>
                <div v-else>
                  <span v-if="scope.row.distrType == '40'">关闭</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="推荐库位"
              prop="laCodeAdvise"
              align="center"
              min-width="100"
            >
            </el-table-column>
            <el-table-column label="实际库位" prop="laCodeReal" align="center" min-width="100">
            </el-table-column>
            <el-table-column label="规值" prop="matSpecs" align="center">
            </el-table-column>
            <el-table-column label="箱号" prop="boxBarcode" align="center" min-width="110">
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" align="center" min-width="140">
            </el-table-column>
            <el-table-column label="发起人" prop="person" align="center">
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="120px">
              <template slot-scope="scope">
                <el-tooltip content="关闭拣配详情" placement="top">
                  <el-button
                    type="primary"
                    @click="dialogOpenPD(scope.row)"
                    :disabled="
                      scope.row.scanFlag ||
                      detailsData.operaType == '30' ||
                      scope.row.distrType == '40'
                        ? true
                        : false
                    "
                    icon="el-icon-switch-button"
                    circle
                    class="btnCircle"
                    v-authority="'BACK_MENU3_M11_B4'"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="调整数量" placement="top">
                  <el-button
                    type="warning"
                    icon="el-icon-edit"
                    circle
                    class="btnCircle"
                    @click="addBoxFlag(scope.row)"
                    :disabled="scope.row.scanFlag"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </h-table>
        </el-col>
        <el-col :span="6">
          <div v-if="boxData">
            <h3>调整拣配数量</h3>
            <div style="text-align:left;">
              <p>
                拣货的箱号：<strong>{{ boxData.boxBarcode }}</strong>
              </p>
              <p>
                已拣货数量：<strong>{{ boxData.matQuanOld }}</strong>
              </p>
              <p>
                可分配数量：<strong>{{ boxData.boxQuan }}</strong>
              </p>
              <p>
                调整数量为：<el-input-number
                  v-model="boxData.matQuan"
                  :min="0"
                  :max="boxData.boxQuan"
                  size="mini"
                ></el-input-number>
              </p>
            </div>
            <el-button type="primary" size="small" @click="btnAddBoxQuan()"
              >调整实际拣配数量</el-button
            >
          </div>
          <div v-else style="color: red;cursor: default;">
            暂无数据，请左边表格操作中选择
          </div>
        </el-col>
      </el-row>
      <!-- 采购退货30 外协60 -->
      <h-table
        :headerCellStyle="mainData.headerCellStyle"
        :style="$popups.harvestRecordStyle(0.75)"
        :data="detailsData.data"
        :total.sync="detailsData.total"
        @selectionChange="checkboxDet"
        v-show="detailsData.operaType == '30' || detailsData.operaType == '60'"
      >
        <el-table-column
          type="selection"
          align="center"
          :selectable="checkboxSelect"
        >
        </el-table-column>
        <el-table-column label="拣货单号" prop="spCode" align="center">
        </el-table-column>
        <el-table-column label="物料编号" prop="matCode" align="center">
        </el-table-column>
        <el-table-column label="物料描述" prop="matName" align="center">
        </el-table-column>
        <el-table-column label="物料数量" prop="matQuan" align="center">
        </el-table-column>
        <el-table-column label="实际拣货数量" align="center" prop="matQuan">
        </el-table-column>
        <el-table-column label="拣货扫描" align="center">
          <template slot-scope="scope">
            {{ scope.row.scanFlag ? "已扫描" : "未扫描" }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <div v-if="detailsData.operaType == '10'">
              <span v-if="scope.row.distrType == '10'">待配送</span>
              <span v-if="scope.row.distrType == '20'">配送中</span>
              <span v-if="scope.row.distrType == '30'">配送完成</span>
              <span v-if="scope.row.distrType == '40'">关闭</span>
            </div>
            <div v-else>
              <span v-if="scope.row.distrType == '40'">关闭</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="推荐库位" prop="laCodeAdvise" align="center">
        </el-table-column>
        <el-table-column label="实际库位" prop="laCodeReal" align="center">
        </el-table-column>
        <el-table-column label="规值" prop="matSpecs" align="center">
        </el-table-column>
        <el-table-column label="箱号" prop="boxBarcode" align="center">
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center">
        </el-table-column>
        <el-table-column label="拣货操作员" prop="person" align="center">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              class="btn-t-edit"
              type="primary"
              @click="dialogOpenPD(scope.row)"
              :disabled="
                scope.row.scanFlag ||
                detailsData.operaType == '30' ||
                scope.row.distrType == '40'
                  ? true
                  : false
              "
              >关闭</el-button
            >
          </template>
        </el-table-column>
      </h-table>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="dialogClose" type="info" class="btn-t-info"
          >取 消</el-button
        >
        <el-button
          @click="pickStockReturnList()"
          type="danger"
          class="btn-t-edit"
          :disabled="buttonShow"
          v-authority="'BACK_MENU3_M11_B5'"
          >确认拣货</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="关闭拣货详情"
      :visible.sync="closePickDShow"
      width="700px"
      :style="$popups.popups(0.8, 0.8)"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-form-item label="拣货单号" class="EL-Form-Item">
          <el-input v-model="closeObj.spCode" readonly />
        </el-form-item>
        <el-form-item label="物料编号" class="EL-Form-Item">
          <el-input v-model="closeObj.matCode" readonly />
        </el-form-item>
        <el-form-item label="实际库位" class="EL-Form-Item">
          <el-input v-model="closeObj.laCodeReal" readonly />
        </el-form-item>
        <el-form-item label="箱号" class="EL-Form-Item">
          <el-input v-model="closeObj.boxBarcode" readonly />
        </el-form-item>
        <el-form-item label="备注" class="EL-Form-Item">
          <el-input v-model="closeObj.remarks" type="textarea" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogClosePD()" type="info" class="btn-t-info"
          >取 消</el-button
        >
        <el-button @click="closePickDetail()" type="danger" class="btn-t-edit"
          >确认关闭</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="打印"
      :visible.sync="printShow"
      width="1500px"
      :close-on-click-modal="false"
    >
      <v-print :doPrint.sync="print">
        <div id="demo" class="demo">
          <div>
            <div style="margin-left: -1200px; margin-top: 50px">
              {{ timeDate }}
            </div>
            <div style="margin-right: -1200px; margin-top: 50px">
              <el-button
                size="small"
                type="primary"
                @click="clearPrintData"
                v-if="showPrise"
              >
                清空数据
              </el-button>
            </div>
            <div
              style="font-size: 30px;font-weight: 600;margin-top: 20px;text-align: center;"
            >
              {{ operaType }}拣货单
            </div>
            <div class="div" style="margin-top: 10px; font-size: 20px">
              <!-- <span>工序：</span> -->
              <span>通道：{{ whCodes }}</span>
              <span>班次：{{ shift }}</span>
              <span>申请人：{{ persons }}</span>
              <span>日期：{{ createTime }}</span>

              <span>拣货单号：{{ dySpCode }}</span>
              <span>工单号：{{ opCode }}</span>
              <!--<span>拣货（通道）：</span>-->
            </div>
            <div class="table">
              <table width="100%" border="1" cellpadding="0" cellspacing="0">
                <tr>
                  <th></th>
                  <th colspan="4">通道下单</th>
                  <th colspan="4">通道接单</th>
                  <!-- <th colspan="2">通道接料</th> -->
                </tr>
                <tr class="td">
                  <td>序号</td>
                  <td>型号</td>
                  <td>描述</td>
                  <td>规值</td>
                  <td>批次号</td>
                  <td>数量（pcs）</td>
                  <td>实发库位</td>
                  <td>箱号</td>
                  <!-- <td>数量</td> -->
                  <td>实发数量</td>
                  <td>仓库类型</td>
                  <td>备注</td>
                </tr>
                <tr v-for="(item, index) in printList" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.matCode }}</td>
                  <td>{{ item.matName }}</td>
                  <td>{{ item.matSpecs }}</td>
                  <td>{{ item.batchNo }}</td>
                  <td>{{ item.demandMatQuan }}</td>
                  <td>{{ item.laCodeReal }}</td>
                  <td>{{ item.boxBarcode }}</td>
                  <td>{{ item.matQuan }}</td>
                  <td>{{ item.saleFlag == true ? "寄" : "非" }}</td>
                  <td>{{ item.remark }}</td>
                  <!-- <td>{{ item.matQuan }}</td> -->
                </tr>
              </table>
            </div>
            <div class="div" style="margin-top: 10px; font-size: 20px">
              <span>总数量：{{ summarySumNumber }}</span>
              <span>箱数：{{ boxNumber }}</span>
              <span>发货（库房）：{{ userName }}</span>
              <!--<span>配送人：{{ confimrPersonNumber}}</span>-->
            </div>
          </div>
        </div>
      </v-print>

      <div style="margin-top: 50px;height:80px">
        <el-button class="btn-t-edit" @click="printShow = false"
          >取消</el-button
        >
        <el-button class="btn-t-edit" @click="printShowMethod()"
          >打印</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import printJS from "print-js";
import moment from "moment";
import vPrint from "syl-vue-printer";
import htmlToPdf from "@/libs/htmlToPdf";
export default {
  name: "PickingConfirmationMat",
  components: {
    vPrint
  },
  data() {
    return {
      printList: [],
      printShow: false,
      print: false,
      printObj: {
        id: "demo",
        popTitle: ""
      },
      mainSearch: {
        person: localStorage.getItem("user"),
        fcCode: localStorage.getItem("fcCode") || "",
        spCode: "",
        status: "EXECUTE",
        pickFlag: false,
        operaType: "10,30,60",
        operaCode: "",
        matCode: "",
        matName: "",
        whCode: "",
        date: [],
        materialType: ""
      },
      pickStatus: "WAITEXECUTE,EXECUTE",
      shift: "",
      dySpCode: "",
      opCode: "",
      confimrPersonNumber: "",

      mainData: {
        data: [],
        nowPage: 1,
        pageSize: 20,
        total: 0,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        }
      },
      detailsData: {
        nowPage: 1,
        pageSize: 50,
        total: 0,
        data: [],
        operaType: ""
      },
      // 详情
      mainDetails: [],
      detailsDialogShow: false,
      checkListDet: [],
      checkList: [],
      boxData: {},

      //重新推荐库位
      laCodeEditBoxShow: false,
      laCodeMainObj: {
        matCode: "",
        matName: "",
        matQuan: "",
        laCode: "",
        operaType: "10",
        operaCode: "",
        fcCode: "",
        person: ""
      },
      laCodeMainObjRules: {
        laCode: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        swlContent: [
          {
            required: true,
            message: "请选择",
            trigger: "blur"
          }
        ]
      },
      warnTypeList: [],
      spdId: "",
      spId: "",
      buttonShow: true,

      warehouseList: "",

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注

      timeDate: new Date(),
      createTime: "",
      whCodes: "",
      persons: localStorage.getItem("userName"),
      userName: localStorage.getItem("userName"),
      showPrise: true,

      downloadLoading: false, //下载中

      closePickDShow: false,
      closeObj: {},
      // 输入框延时加载
      isSetTimeout: null,

      //打印类型
      operaType: "",
      //总数量
      sumNumber: 0,
      //汇总总数量
      summarySumNumber: 0,
      //总箱数
      boxNumber: 0,
      //单据打印的数据
      spIdList: [],
      //汇总对象
      SummaryData: {},
      //集合
      printsList: [] //用户关联的工厂
    };
  },
  watch: {
    mainSearch: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.mainData.nowPage = 1;
          this.getStockPickPage(newVal);
        }, 1000);
      },
      deep: true
    }
  },
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[0]) {
            return time.getTime() < new Date(_this.mainSearch.date[0]);
          }
        }
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[1]) {
            return time.getTime() > new Date(_this.mainSearch.date[1]);
          }
        }
      };
    }
  },
  methods: {
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.mainData.nowPage = 1;
        this.getStockPickPage();
      }, 1000);
    },
    handleDown() {
      // console.log(document.querySelector("#demo"));
      htmlToPdf.downloadPDF(document.querySelector("#demo"), "X-R控制图");
    },
    //清空打印数据
    clearPrintData() {
      this.printList = [];
      this.spIdList = [];
      this.summarySumNumber = 0;
      this.sumNumber = 0;
      this.boxNumber = 0;
      this.whCodes = "";
    },
    getPrintList() {
      this.clearPrintData();
      this.persons = "";
      this.shift = "";
      this.showPrise = true;
      if (this.checkList.length == 0) {
        this.printShow = true;
      } else {
        var code = 0;
        var whCode = "";
        if (this.checkList[0].realWhCode != "") {
          whCode = this.checkList[0].realWhCode;
        } else {
          whCode = this.checkList[0].whCode;
        }
        var reamrk = "";

        this.checkList.forEach(item => {
          // if (item.whCode != whCode) {
          //     code += 1;
          // }
          reamrk = item.remark;
          if (this.spIdList.indexOf(item.spId) < 0) {
            this.spIdList.push(item.spId);
            //this.sumNumber += item.matQuan;
          }
        });

        // if (code != 0) {
        //     this.$message({
        //         message: "请勾选同一通道下的拣货单！",
        //         type: "warning",
        //     });
        //     return
        // }

        var spId = this.spIdList.join(",");

        if (this.checkList[0].operaType == "10") {
          this.operaType = "叫料";
        } else if (this.checkList[0].operaType == "20") {
          this.operaType = "部门领用";
        } else if (this.checkList[0].operaType == "30") {
          this.operaType = "采购退货";
        } else if (this.checkList[0].operaType == "50") {
          this.operaType = "冻结";
        } else if (this.checkList[0].operaType == "60") {
          this.operaType = "外协";
        }
        //this.whCodes = whCode;
        //this.printShow = true;
        this.$http
          .request({
            url: "/api/order/getPickNotCloseList",
            method: "GET",
            params: {
              pageNum: 0,
              pageSize: 0,
              spId: spId || null
            }
          })
          .then(resp => {
            if (resp.status == 100) {
              if (resp.data.list != null) {
                this.printsList = resp.data.list;
                var matCode = resp.data.list[0].matCode || "";
                this.printList = [];
                this.summarySumNumber = 0;
                this.sumNumber = 0;
                this.printsList.forEach((item, index) => {
                  if (
                    item.shift != undefined &&
                    this.shift.indexOf(item.shift) == -1
                  ) {
                    this.shift = this.shift + "," + item.shift;
                  }
                  if (this.persons.indexOf(item.person) == -1) {
                    this.persons = this.persons + "," + item.person;
                  }
                  if (item.demandMatQuan == undefined) {
                    item.demandMatQuan = item.matQuan;
                  }
                  if (matCode == item.matCode) {
                    this.sumNumber += item.matQuan;
                    item.remark = reamrk;
                    this.printList.push(item);
                  } else {
                    //this.printList.push({ matQuan: this.sumNumber });
                    this.printList.push(item);
                    matCode = item.matCode;
                    this.summarySumNumber += this.sumNumber;
                    this.sumNumber = item.matQuan;
                  }
                  var date = new Date(item.createTime);
                  this.createTime =
                    date.getFullYear() +
                    "/" +
                    (date.getMonth() + 1) +
                    "/" +
                    date.getDate();
                  this.dySpCode = item.spCode;
                  this.opCode = item.opCode;
                  this.whCodes =
                    item.whCode +
                    (item.realWhCode == undefined ||
                    item.whCode == item.realWhCode
                      ? ""
                      : "," + item.realWhCode);
                  this.confimrPersonNumber = item.confimrPersonNumber;
                });
                this.persons = this.persons.substring(1, this.persons.length);
                if (this.shift != "" && this.shift.substring(0, 1) == ",") {
                  this.shift = this.shift.substring(1, this.shift.length);
                }
                //this.printList.push({ matQuan: this.sumNumber });

                this.summarySumNumber += this.sumNumber;
                this.boxNumber = resp.data.total;
                this.printShow = true;
              } else {
                this.$message({
                  message: "未找到拣货详情打印记录！",
                  type: "warning"
                });
              }
            }
          });
      }
    },
    /**
     * 获取当前时间
     * 格式YYYY-MM-DD
     */
    getTime() {
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      this.timeDate = year + seperator1 + month + seperator1 + strDate;
    },

    /**
     * 查询拣货单记录
     */
    getStockPickPage() {
      if (this.pickStatus == "WAITEXECUTE") {
        this.mainSearch.status = "EXECUTE";
        this.mainSearch.pickFlag = false;
      } else if (this.pickStatus == "EXECUTE") {
        this.mainSearch.pickFlag = true;
      } else if (this.pickStatus == "WAITEXECUTE,EXECUTE") {
        this.mainSearch.status = "EXECUTE";
        this.mainSearch.pickFlag = null;
      } else {
        this.mainSearch.status = this.pickStatus;
        this.mainSearch.pickFlag = null;
      }
      const empNumber = localStorage.getItem("empNumber") || null;
      this.$http
        .request({
          url: "/api/order/getStockPickPage",
          method: "GET",
          params: {
            // person: this.mainSearch.person || null,
            whCode: this.mainSearch.whCode || null,
            fcCode: this.mainSearch.fcCode || null,
            spCode: this.mainSearch.spCode || null,
            spStatus: this.mainSearch.status || null,
            pickFlag: this.mainSearch.pickFlag,
            operaType: this.mainSearch.operaType || null,
            operaCode: this.mainSearch.operaCode || null,
            matCode: this.mainSearch.matCode || null,
            matName: this.mainSearch.matName || null,
            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
            materialType: this.mainSearch.materialType || null,
            pageNum: this.mainData.nowPage,
            pageSize: this.mainData.pageSize,
            empNumber
          }
        })
        .then(resp => {
          if (resp.status == 100) {
            this.mainData.data = resp.data.list || [];
            this.mainData.total = resp.data.total;
          }
        })
        .catch(error => {
          this.$message({
            message: "操作失败",
            type: "warning"
          });
        });
    },

    /**
     * 详情
     */
    detailsDialog(row) {
      if (row.spStatus == "EXECUTE") {
        this.buttonShow = false;
      } else {
        this.buttonShow = true;
      }
      this.detailsData.operaType = row.operaType;
      this.detailsData.data = [];
      this.detailsDialogShow = true;
      this.getStockPickDetailList(row.spId);
      this.spId = row.spId;
    },

    /**
     * 查询拣货单详情记录
     */
    getStockPickDetailList(spId) {
      this.$http
        .request({
          url: "/api/order/getStockPickDetailList",
          method: "GET",
          params: {
            // pageNum: this.detailsData.nowPage,
            // pageSize: this.detailsData.pageSize,
            spId: spId || null
          }
        })
        .then(resp => {
          if (resp.status == 100) {
            this.detailsData.data = resp.data.list || [];
            this.detailsData.total = resp.data.total;
          }
        })
        .catch(error => {
          this.$message({
            message: "操作失败",
            type: "warning"
          });
        });
    },

    /**
     * 多选
     */
    checkboxMain(val) {
      this.checkList = val;
    },
    checkboxDet(val) {
      this.checkListDet = val;
    },
    //禁选
    checkboxSelect(row, rowIndex) {
      if (row.scanFlag || row.distrType == "40") {
        return false; // 禁用
      } else {
        return true; // 不禁用
      }
    },
    checkboxMainSelect(row, rowIndex) {
      if (row.spStatus != "CREATE" && row.spStatus != "EXECUTE") {
        return false; // 禁用
      } else {
        return true; // 不禁用
      }
    },

    /**
     * 拣货单-确认拣货
     */
    pickStockReturnPage() {
      if (this.checkList.length == 0) {
        this.$message({
          message: "请先勾选记录！",
          type: "warning"
        });
        return;
      }
      this.$confirm("是否确认拣货?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let spCodes = "";
        let operaCodes = "";
        this.checkList.forEach(element => {
          spCodes = spCodes + element.spCode + ",";
          operaCodes = operaCodes + element.operaCode + ",";
        });
        this.$http
          .request({
            url: "/api/order/pickStockReturnPage",
            method: "POST",
            showLoading: true,
            params: {
              spCodes: spCodes,
              operaCodes: operaCodes,
              person: localStorage.getItem("user") && "",
              personNumber: localStorage.getItem("empNumber") || null
            }
          })
          .then(resp => {
            if (resp.status == 100) {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.logRemarks = "order：确认拣货成功";
            } else {
              this.$message({
                message: resp.message,
                type: "error"
              });
              this.logRemarks = "order：确认拣货失败";
            }
            this.logContent =
              "spCodes" + spCodes + "\t" + "operaCodes" + operaCodes;
            this.systemLog();
            //刷新数据
            this.getStockPickPage();
          });
      });
    },

    /**
     * 拣货记录-确认拣货
     */
    pickStockReturnList() {
      if (this.checkListDet.length == 0) {
        this.$message({
          message: "请先勾选记录！",
          type: "warning"
        });
        return;
      }
      this.$confirm("是否确认拣货?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .request({
              url:
                "/api/order/pickStockReturnList/" +
                localStorage.getItem("user"),
              method: "POST",
              showLoading: true,
              data: this.checkListDet,
              params: {
                personNumber: localStorage.getItem("empNumber") || null
              }
            })
            .then(resp => {
              if (resp.status == 100) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.logRemarks = "PICK：确认拣货成功";

                //打印拆包标签
                this.rePrintBarcode(resp.data);
              } else {
                this.$message({
                  message: resp.message,
                  type: "error"
                });
                this.logRemarks = "PICK：确认拣货失败";
              }
              this.logContent =
                "personNumber: " +
                localStorage.getItem("empNumber") +
                JSON.stringify(this.checkListDet);
              this.systemLog();
              //刷新数据
              this.dialogClose();
            })
            .catch(error => {
              this.$message({
                message: "操作失败",
                type: "warning"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消收货"
          });
        });
    },

    //标签打印
    rePrintBarcode(selectAllPrintList) {
      if (selectAllPrintList == undefined || selectAllPrintList.length == 0) {
        return;
      }
      selectAllPrintList.forEach(item => {
        var produceTime = moment(item.matCreateTime).format("YYYYMMDD");

        if (item.matSpecs == undefined) {
          item.matSpecs = "";
        }

        var person = localStorage.getItem("user");
        if (person != undefined && person != "") {
          person = item.consignee;
        }

        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
        var barcodeData = {
          boxBarcode: item.boxBarcode,
          prodCode: item.matCode,
          prodName: item.matName,
          batchNo: item.batchNo,
          count: item.matQuan,
          checkPerson: person,
          date: produceTime,
          poCode: item.orderCode,
          matSpecs: item.matSpecs,
          whCode: item.whCode,
          qrCode: "",
          supply: item.verdorCode,
          printTime: printTime,
          isSta: false,
          printTwo: false,
          location: item.lcCode,
          boxHeight: item.boxHeight,
          titleType: item.titleType
        };
        this.$printer.printWMSBarcode(barcodeData);
      });
    },

    dialogClose() {
      this.detailsDialogShow = false;
      this.getStockPickPage();
      this.clearBoxData();
    },

    //表单验证
    submitForm(formName) {
      let r = Boolean;
      this.$refs[formName].validate(valid => {
        if (valid) {
          r = true;
        } else {
          r = false;
        }
      });
      return r;
    },

    /**
     * 重置
     */
    mainReset() {
      this.mainSearch = {
        person: localStorage.getItem("user"),
        fcCode: localStorage.getItem("fcCode") || "",
        spCode: "",
        status: "EXECUTE",
        pickFlag: false,
        operaType: "10,30,60",
        operaCode: "",
        matCode: "",
        matName: "",
        whCode: "",
        date: [],
        materialType: ""
      };
      this.pickStatus = "WAITEXECUTE,EXECUTE";
    },

    getWarehouse() {
      this.$http
        .request({
          url: "/api/warehouse/getWarehouse",
          method: "GET",
          params: {
            fcCode: localStorage.getItem("fcCode") || ""
          }
        })
        .then(resp => {
          if (resp.status == 100) {
            this.warehouseList = resp.data.list || [];
          }
        })
        .catch(error => {
          this.loading++;
        });
    },
    //关闭拣货详情
    dialogOpenPD(row) {
      this.closeObj = row;
      this.closePickDShow = true;
    },
    dialogClosePD() {
      this.closeObj = {};
      this.closePickDShow = false;
      this.getStockPickDetailList(this.spId);
    },
    printShowMethod() {
      this.showPrise = false;
      setTimeout(() => {
        this.print = true;
        this.printShow = false;
      }, 500);
    },
    closePickDetail() {
      this.$confirm("确认关闭该箱物料的拣货详情?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .request({
              url: "/api/stockPickDetail/closePickDetail",
              method: "POST",
              showLoading: true,
              params: {
                spdId: this.closeObj.spdId,
                person: localStorage.getItem("user") || "",
                personNumber: localStorage.getItem("empNumber") || "",
                remarks: this.closeObj.remarks
              }
            })
            .then(resp => {
              if (resp.status == 100) {
                this.$message({
                  type: "success",
                  message: "关闭成功"
                });
                this.logRemarks = "PICK：关闭拣货详情成功";
              } else {
                this.$message({
                  type: "error",
                  message: resp.message
                });
                this.logRemarks = "PICK：关闭拣货详情失败";
              }
              this.logContent =
                "person: " +
                localStorage.getItem("user") +
                ", personNumber: " +
                localStorage.getItem("empNumber") +
                JSON.stringify(this.closeObj);
              this.systemLog();
              this.dialogClosePD();
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: "关闭失败"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消关闭"
          });
        });
    },
    //表格导出
    downLoadFile(type) {
      this.downloadLoading = true;
      if (this.pickStatus == "WAITEXECUTE") {
        this.mainSearch.status = "EXECUTE";
        this.mainSearch.pickFlag = false;
      } else if (this.pickStatus == "EXECUTE") {
        this.mainSearch.pickFlag = true;
      } else if (this.pickStatus == "WAITEXECUTE,EXECUTE") {
        this.mainSearch.status = "EXECUTE";
        this.mainSearch.pickFlag = null;
      } else {
        this.mainSearch.status = this.pickStatus;
        this.mainSearch.pickFlag = null;
      }
      var paramsObj = {
        // person: this.mainSearch.person || null,
        whCode: this.mainSearch.whCode || null,
        fcCode: this.mainSearch.fcCode || null,
        spCode: this.mainSearch.spCode || null,
        spStatus: this.mainSearch.status || null,
        pickFlag: this.mainSearch.pickFlag,
        operaType: this.mainSearch.operaType || null,
        operaCode: this.mainSearch.operaCode || null,
        matCode: this.mainSearch.matCode || null,
        matName: this.mainSearch.matName || null,
        beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
        endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
        materialType: this.mainSearch.materialType || null,
        pageNum: 1,
        pageSize: 999999
      };
      this.$http
        .request({
          url: "/api/order/getStockPickPage",
          method: "GET",
          params: paramsObj
        })
        .then(resp => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败"
              });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then(excel => {
        list.forEach(function(c) {
          if (c.operaType == "10") {
            c["operaType"] = "生产叫料";
          } else if (c.operaType == "20") {
            c["operaType"] = "部门领用";
          } else if (c.operaType == "30") {
            c["operaType"] = "采购退货";
          } else if (c.operaType == "40") {
            c["operaType"] = "调拨移库";
          } else if (c.operaType == "60") {
            c["operaType"] = "外协";
          }

          if (c.whCode != c.realWhCode) {
            c.realWhCode = c.realWhCode + "(" + c.whCode + ")";
          }

          if (c.spStatus == "CREATE") {
            c["spStatus"] = "创建";
          } else if (c.spStatus == "EXECUTE" && !c.pickFlag) {
            c["spStatus"] = "待拣配";
          } else if (c.spStatus == "EXECUTE" && c.pickFlag) {
            c["spStatus"] = "拣配中";
          } else if (c.spStatus == "COMPLETE") {
            c["spStatus"] = "完成";
          } else if (c.spStatus == "CANCEL") {
            c["spStatus"] = "取消";
          } else if (c.spStatus == "CLOSE") {
            c["spStatus"] = "关闭";
          }

          if (c.topFlag == true) {
            c["topFlag"] = "是";
          } else {
            c["topFlag"] = "否";
          }
        });
        const tHeader = [
          "通道编号",
          "物料类型",
          "物料编号",
          "物料描述",
          "物料数量",
          "实际拣货数量",
          "拣货状态",
          "拣货类型",
          "拣货单号",
          "创建时间",
          "是否紧急",
          "紧急原因",
          "规值",
          "拣货人",
          "操作人"
        ];
        const filterVal = [
          "realWhCode",
          "materialType",
          "matCode",
          "matName",
          "matQuan",
          "realPickMat",
          "spStatus",
          "operaType",
          "spCode",
          "createTime",
          "topFlag",
          "topMessage",
          "matSpecs",
          "pickPerson",
          "person"
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "叫料确认单"
        });
        this.logContent = "导出";
        this.logRemarks = "stock_pick：导出叫料确认记录";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "叫料确认",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") && ""
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          showLoading: true,
          data: objData
        })
        .then(resp => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch(error => {});
    },
    /**
     * 调整拣货数量
     */
    addBoxFlag(row) {
      this.boxData = this.deepCopy(row);
      this.boxData.boxQuan = row.matQuanMore + row.matQuan;
      this.boxData.matQuanOld = row.matQuan;
    },

    btnAddBoxQuan() {
      if (!this.boxData || this.boxData.matQuan == undefined) {
        this.$message({
          message: "箱信息为空",
          type: "warning"
        });
        return;
      }
      if (this.boxData.matQuan <= 0) {
        this.$message({
          message: "调整后的拣配数量必须大于0",
          type: "warning"
        });
        return;
      }
      if (this.boxData.matQuan > this.boxData.boxQuan) {
        this.$message({
          message: "调整后的拣配数量不得超过库存数量",
          type: "warning"
        });
        return;
      }
      if (this.boxData.matQuan == this.boxData.matQuanOld) {
        this.$message({
          message: "调整后的拣配数量没有改变",
          type: "warning"
        });
        return;
      }
      if (!this.boxData.boxBarcode) {
        this.$message({
          message: "箱信息为空",
          type: "warning"
        });
        return;
      }
      //调整拣配数量
      this.$http
        .request({
          url: "/api/stockPickDetail/increasePickQuan",
          method: "PUT",
          data: this.boxData
        })
        .then(resp => {
          if (resp.status == 100) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.logRemarks = "pick：拣配数量调整成功";
          } else {
            this.$message({
              message: resp.message,
              type: "error"
            });
            this.logRemarks = "pick：拣配数量调整失败";
          }
          this.logContent = JSON.stringify(this.boxData);
          this.systemLog();
          //刷新数据
          this.clearBoxData();
          this.getStockPickDetailList(this.spId);
        })
        .catch(error => {
          this.$message({
            message: "操作失败",
            type: "error"
          });
        });
    },
    clearBoxData() {
      this.boxData = {};
    }
  },
  activated() {
    // 从页面跳转传值
    let spCode = this.$route.query.spCode;
    if (spCode) {
      this.mainSearch.spCode = spCode;
    } else {
      this.getStockPickPage();
    }
    this.getWarehouse();
    this.getTime();
  }
};
</script>
<style>
.div span {
  margin-left: 50px;
}

.table table {
  margin-top: 20px;
}

.table table tr td {
  width: 100px;
  height: 50px;
  border: 1px solid black;
  text-align: center;
}

.table table tr th {
  width: 100px;
  height: 80px;
  border: 1px solid black;
  font-weight: 800;
  font-size: 18px;
}

.td td {
  font-weight: 800;
}

.btnCircle {
  padding: 5px !important;
  height: auto !important;
  font-size: 12px !important;
}
</style>
